import Icon from '../../components/Icon.vue'

Icon.register({"regular/calendar-plus":{"width":448,"height":512,"paths":[{"d":"M336 292V316C336 322.6 330.6 328 324 328H248V404C248 410.6 242.6 416 236 416H212C205.4 416 200 410.6 200 404V328H124C117.4 328 112 322.6 112 316V292C112 285.4 117.4 280 124 280H200V204C200 197.4 205.4 192 212 192H236C242.6 192 248 197.4 248 204V280H324C330.6 280 336 285.4 336 292zM448 112V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112zM400 458V160H48V458C48 461.3 50.7 464 54 464H394C397.3 464 400 461.3 400 458z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/calendar-plus.js
// module id = null
// module chunks = 